import { render } from "./ProfilePrefs.view.vue?vue&type=template&id=15fa4a42"
import script from "./ProfilePrefs.view.vue?vue&type=script&lang=js"
export * from "./ProfilePrefs.view.vue?vue&type=script&lang=js"

import "./ProfilePrefs.view.vue?vue&type=style&index=0&id=15fa4a42&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__